export default function (text, replacements = {}) {
    return i18n.translate(text, replacements);
};
